import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { openNewVisualMailing } from '../mailing-constructor/visualMailingNavigate';
import i18next from '../../i18n/initI18n';

/**
 * /scenarios/new → новая визуальная цепочка.
 * /scenarios/mc_* → редактор визуальной цепочки (сервер).
 * Иначе → список визуальных цепочек (серверные UUID без формы больше не редактируются здесь).
 */
const ScenarioRedirect: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  useEffect(() => {
    let cancelled = false;
    void (async () => {
      if (!id) {
        navigate({ pathname: '/', search: '?tab=scenarios' }, { replace: true });
        return;
      }
      if (id === 'new') {
        try {
          await openNewVisualMailing(navigate, i18next.t('common.newChain'));
        } catch {
          if (!cancelled) {
            navigate({ pathname: '/', search: '?tab=scenarios' }, { replace: true });
          }
        }
        return;
      }
      if (id.startsWith('mc_')) {
        if (!cancelled) navigate(`/mailing/${id}`, { replace: true });
        return;
      }
      if (!cancelled) navigate({ pathname: '/', search: '?tab=scenarios' }, { replace: true });
    })();
    return () => {
      cancelled = true;
    };
  }, [id, navigate]);

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', p: 6 }}>
      <CircularProgress />
    </Box>
  );
};

export default ScenarioRedirect;
